const SubmissionsTabs = {
  PERFORMANCE: 'PERFORMANCE',
  ANSWERS: 'ANSWERS',
  SUBMISSIONS: 'SUBMISSIONS',
  ANALYZE: 'ANALYZE'
};
export default SubmissionsTabs;